<template>
    <q-list no-border>
        <q-list-header class="q-pr-lg text-center q-my-xs">
            <router-link to="/"><img src="../../img/identity/p4f.svg" width="70%"/></router-link>
        </q-list-header>

        <q-item v-for="menu in menus" :key="menu.name"
                v-ripple link item exact class="big" :to="menu.slug">
            {{ $T(menu.name) }}
        </q-item>

        <q-item-separator/>

        <q-item item>
            <div class="row full-width items-baseline">
                <div class="col">
                    <q-input v-model="query" :placeholder="$T('search')"
                             @keydown.enter.prevent="search"/>
                </div>
                <div class="col-auto">
                    <q-btn icon="search" color="primary" class="super-hover on-right"
                           @click.prevent="search"></q-btn>
                </div>
            </div>
        </q-item>

        <q-item-separator/>
        <!--
        Esses dois primeiros ai embaixo deveriam ser dinâmicos tb. Um "submenu"
        O "minha conta" deve verificar se já está logado v-if.
        Assim como o login/esqueci a senha, logout
        -->
        <q-item link :to="{name: 'contact'}">{{ $T('contact us') }}</q-item>
        <q-item link :to="{name: 'terms'}">{{ $T('terms ans conditions') }}</q-item>
        <q-item link to="/profile">{{ $T('my account') }}</q-item>

        <q-item-separator/>
        <q-item>
            <div class="col" v-if="user">
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to pocket4fun!') }}</h6>
                {{ $T('close your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md"
                       :label="$T('log out')" link @click.native="logout"></q-btn>
            </div>

            <div class="col" v-else>
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to pocket4fun!') }}</h6>
                {{ $T('start your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md"
                       :label="$T('log in')" @click.prevent="$login()"></q-btn>
            </div>
        </q-item>
        <q-item>
            <div class="col text-center"><small>© Pocket4Fun - V{{ getVersion() }}</small></div>
        </q-item>

    </q-list>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'

    import {
        QList,
        QListHeader,
        QItem,
        QItemSeparator,
        QBtn,
        QInput
    } from 'quasar-framework'

    export default {
        components: {
            QList,
            QListHeader,
            QItem,
            QItemSeparator,
            QBtn,
            QInput
        },

        data() {
            return {
                logo: `${config.appUrl}${config.devAssetsFolder}/img/p4f.svg`,
                query: ''
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                locale: 'lang/locale',
                locales: 'lang/locales',
            }),

            menus() {
                return window.config.menus
            }
        },

        methods: {
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                this.$router.push({name: "home"})
            },

            setLocale(locale) {
              this.$q.i18n.rtl=false;
              if (this.$i18n.locale !== locale) {
                loadMessages(locale)

                this.$store.dispatch('lang/setLocale', {locale})
                this.$q.i18n.rtl=false;
                window.location.href = this.$route.path
              }
            },

            search() {
                this.$router.push({ name: 'sports.search', params: {query: this.query} })
            },

            getVersion() {
                return `${config.appVersion}`
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue